export default "__VITE_ASSET__d5c587da__"